import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { DeviceStatistic } from '@vindr/services/apis/order.api';
import { Typography, Row, Col } from 'antd';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from '@vindr/ui';
const { Title } = Typography;

interface Widget {
  title: string;
  newItems: number;
  arrivedItems: number;
  completedItems: number;
  active: boolean;
}

const ReceptionBlock = ({ title, newItems, arrivedItems, completedItems, active }: Widget) => {
  const { t } = useTranslation('Vindoc');

  return (
    <div
      className={`rounded-s flex h-full w-full min-w-40 cursor-pointer flex-col justify-between p-3 ${
        active ? 'bg-primary-200' : 'bg-primary-dark'
      }`}
    >
      <Title level={4} className="mb-3">
        {t(title)}
      </Title>
      <div className="text-base">
        <div className="mb-2 flex justify-between">
          <div>{t('New')}</div>
          <div className="ml-2">{newItems}</div>
        </div>
        <div className="mb-2 flex justify-between">
          <div>{t('Arrived')}</div>
          <div className="ml-2">{arrivedItems}</div>
        </div>
        <div className="flex justify-between">
          <div>{t('Completed')}</div>
          <div className="ml-2">{completedItems}</div>
        </div>
      </div>
    </div>
  );
};

const DeviceSelect = forwardRef(
  (
    {
      devices,
      value,
      onChange,
    }: {
      devices: DeviceStatistic[];
      value?: string;
      onChange?: (device_id: string, device: DeviceStatistic) => unknown;
    },
    ref
  ) => {
    const { t } = useTranslation('Vindoc');
    const filterDevices = devices.filter(
      (it) => it.device_name !== 'All devices' && it.device_name !== 'Unknown'
    );

    return (
      <div className="flex flex-col w-full justify-between">
        {!filterDevices?.length && <div className="w-full justify-center"><Empty description={t('No available Device')} /></div>}
        <Row
          gutter={[6, 6]}
          className="grid w-full"
          style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(160px, 1fr))' }}
        >
          {filterDevices.map((it) => (
            <Col key={it?.device_id + it?.device_name} className="flex-1">
              <div onClick={() => onChange(it.device_id, it)} className="h-full">
                <ReceptionBlock
                  title={it.device_name}
                  active={it.device_id === value}
                  newItems={it.status_count[ORDER_STATUS.NEW] || 0}
                  arrivedItems={it.status_count[ORDER_STATUS.ARRIVED] || 0}
                  completedItems={it.status_count[ORDER_STATUS.COMPLETED] || 0}
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
);

export default DeviceSelect;
